import * as Effects from 'redux-saga/effects'
import {
  CertificateManagerType,
  ContractKind,
  ContractKindEng,
  CustomerTypeEnums,
  PaymentGatewayType,
  PaymentGatewayTypeEng,
  PaymentType,
  PaymentTypeEng,
  TypeOfFee,
} from '../../enums'
import {formatter, SetCustomerAddress} from '../../utils'
import {
  searchAndPagingContract,
  searchAndPagingUser,
} from '../../modules/insurance/healthInsurance/apis'
import {searchAndPagingRenewContract} from '../../modules/renew/apis'
import {getListPayment, getListCommission} from '../../modules/payments/apis'
import {getListCertificate, getListCertificateManage} from '../../modules/certificate/api'
import {ActionTypes} from './gridActions'
import {initialState} from './gridInitialState'
import moment from 'moment'
import {getConfig} from '../../../_metronic/i18n/Metronici18n'

const call: any = Effects.call
const takeLatest = Effects.takeLatest
const put = Effects.put

const lang = getConfig().selectedLang

const getAgent = (agentCode: string) => {
  const partner = window.localStorage.getItem('view:partner')
  if (partner) {
    let listPartner = JSON.parse(partner)
    return listPartner.find((o: any) => o.value == agentCode)?.name
  }
  return null
}

const getContractKind = (contractKind: number) => {
  if (lang == 'vi') {
    return ContractKind.find((c) => c.value == contractKind)?.label
  } else {
    return ContractKindEng.find((c) => c.value == contractKind)?.label
  }
}

const getPaymentGatewayType = (paymentGatewayType: number) => {
  if (lang == 'vi') {
    return PaymentGatewayType.find((c) => c.value == paymentGatewayType)?.label
  } else {
    return PaymentGatewayTypeEng.find((c) => c.value == paymentGatewayType)?.label
  }
}

const getPaymentType = (paymentType: number) => {
  if (lang == 'vi') {
    return PaymentType.find((c) => c.value == paymentType)?.label
  } else {
    return PaymentTypeEng.find((c) => c.value == paymentType)?.label
  }
}

export const gridActions = {
  getHealthDataGrid: (data: any) => ({type: 'GETHEALTHDATAGRID', payload: data}),
  saveHealthDataGrid: (data: any) => ({type: 'SAVEHEALTHDATAGRID', payload: data}),
  getAutoDataGrid: (data: any) => ({type: 'GETAUTODATAGRID', payload: data}),
  saveAutoDataGrid: (data: any) => ({type: 'SAVEAUTODATAGRID', payload: data}),
  getMotoDataGrid: (data: any) => ({type: 'GETMOTODATAGRID', payload: data}),
  saveMotoDataGrid: (data: any) => ({type: 'SAVEMOTODATAGRID', payload: data}),
  getHouseDataGrid: (data: any) => ({type: 'GETHOUSEDATAGRID', payload: data}),
  saveHouseDataGrid: (data: any) => ({type: 'SAVEHOUSEDATAGRID', payload: data}),
  getCustomerDataGrid: (data: any) => ({type: 'GETCUSTOMERDATAGRID', payload: data}),
  saveCustomerDataGrid: (data: any) => ({type: 'SAVECUSTOMERDATAGRID', payload: data}),
  getPaymentDataGrid: (data: any) => ({type: 'GETPAYMENTDATAGRID', payload: data}),
  savePaymentDataGrid: (data: any) => ({type: 'SAVEPAYMENTDATAGRID', payload: data}),
  getCertificateDataGrid: (data: any) => ({type: 'GETCERTIFICATEDATAGRID', payload: data}),
  saveCertificateDataGrid: (data: any) => ({type: 'SAVECERTIFICATEDATAGRID', payload: data}),
  getCertificateManageDataGrid: (data: any) => ({
    type: 'GETCERTIFICATEMANAGEDATAGRID',
    payload: data,
  }),
  saveCertificateManageDataGrid: (data: any) => ({
    type: 'SAVECERTIFICATEMANAGEDATAGRID',
    payload: data,
  }),
  getCommissionDataGrid: (data: any) => ({type: 'GETCOMMISSIONDATAGRID', payload: data}),
  saveCommissionDataGrid: (data: any) => ({type: 'SAVECOMMISSIONDATAGRID', payload: data}),
  getRenewDataGrid: (data: any) => ({type: 'GETRENEWDATAGRID', payload: data}),
  saveRenewDataGrid: (data: any) => ({type: 'SAVERENEWDATAGRID', payload: data}),
  getCheckMoneyDataGrid: (data: any) => ({type: 'GETCHECKMONEYDATAGRID', payload: data}),
  saveCheckMoneyDataGrid: (data: any) => ({type: 'SAVECHECKMONEYDATAGRID', payload: data}),
  getPaymentSalaryDataGrid: (data: any) => ({type: 'GETPAYMENTSALARYDATAGRID', payload: data}),
  savePaymentSalaryDataGrid: (data: any) => ({type: 'SAVEPAYMENTSALARYDATAGRID', payload: data}),
  clearDataGrid: (grid: string) => ({type: 'CLEARDATAGRID', payload: grid}),
  getCargoDataGrid: (data: any) => ({type: 'GETCARGODATAGRID', payload: data}),
  saveCargoDataGrid: (data: any) => ({type: 'SAVECARGODATAGRID', payload: data}),
  getMarineDataGrid: (data: any) => ({type: 'GETMARINEDATAGRID', payload: data}),
  saveMarineDataGrid: (data: any) => ({type: 'SAVEMARINEDATAGRID', payload: data}),
  getPropertyDataGrid: (data: any) => ({type: 'GETPROPERTYDATAGRID', payload: data}),
  savePropertyDataGrid: (data: any) => ({type: 'SAVEPROPERTYDATAGRID', payload: data}),
  getTechnicalDataGrid: (data: any) => ({type: 'GETTECHNICALDATAGRID', payload: data}),
  saveTechnicalDataGrid: (data: any) => ({type: 'SAVETECHNICALDATAGRID', payload: data}),
  getMicroDataGrid: (data: any) => ({type: 'GETMICRODATAGRID', payload: data}),
  saveMicroDataGrid: (data: any) => ({type: 'SAVEMICRODATAGRID', payload: data}),
}

export const gridReducer = (state = initialState, action: ActionTypes) => {
  switch (action.type) {
    case 'CLEARDATAGRID':
      const clearState = JSON.parse(JSON.stringify(state))
      if (action.payload) {
        clearState[action.payload].data = []
        clearState[action.payload].totalRow = undefined
      }
      return clearState
    case 'GETHEALTHDATAGRID':
      return state
    case 'SAVEHEALTHDATAGRID':
      const gridState = JSON.parse(JSON.stringify(state))
      if (action.payload) {
        gridState.healthGrid.totalRow = action.payload.totalItems
        gridState.healthGrid.data = []
        action.payload.items.map((o: any) => {
          let obj = {
            id: o.id,
            customerCode: o.customerCode,
            customerVersion: o.customerVersion,
            contractNumber: o.contractNumber,
            originalNumber: o.originalNumber,
            groupDomainCode: o.groupDomainCode,
            groupDomainName: o.groupDomainName,
            customerName: o.customerName,
            sumFee: formatter(o.sumFee),
            sumFeeName: formatter(o.sumFee, o.curencyFee) + ' ' + o.curencyFee,
            createdDate: o.createdDate,
            expireDate: o.expireDate,
            source: o.source,
            purchaseDate: o.purchaseDate,
            startDate: o.startDate,
            endDate: o.endDate,
            statusName: o.statusName,
            manager: o.manager,
            PIC:o.pic,
            managerName: o.managerName,
            userCreatedName: o.userCreatedName,
            partnerCode: o.partnerCode,
            divisionCode: o.divisionCode,
            partnerName: o.partnerName,
            divisionName: o.divisionName,
            quatationNumber: o?.quatationNumber,
            contractTypeName: o.contractTypeName,
            contractType: o.contractType,
            contractKind: o.contractKind,
            companyNameMaster: o.customerMasterName,
            paymentGatewayTypeName: getPaymentGatewayType(o.paymentGatewayType),
            paymentTypeName: o.paymentType != 0 ? getPaymentType(o.paymentType) : null,
            contractKindName: o.contractKind ? getContractKind(o.contractKind) : '',
            agent: getAgent(o.exploitingCode),
            productCode: o.productCode,
            divisionId: o.divisionId,
          }
          gridState.healthGrid.data.push(obj)
        })
      }
      return gridState
    case 'GETCUSTOMERDATAGRID':
      return state
    case 'SAVECUSTOMERDATAGRID':
      const customerGridState = JSON.parse(JSON.stringify(state))
      if (action.payload) {
        customerGridState.customerGrid.totalRow = action.payload.totalItems
        customerGridState.customerGrid.data = []
        if (action.payload.items && action.payload.items.length > 0) {
          action.payload.items.map((o: any) => {
            let obj = {
              id: o.id.toString(),
              customerCode: o.customerCode,
              customerType: o.customerType
                ? CustomerTypeEnums.find((c) => c.value == o.customerType)?.label
                : '',
              customerName: o.name,
              customerAddress: SetCustomerAddress(
                o.addressName,
                o.subDistrict,
                o.district,
                o.province
              ),
              customerPlace: o.country,
              customerPhone: o.customerType == 2 ? o.phone : o.mobile,
              customerIdentity: o.identificationNumber ? o.identificationNumber : o.taxNumber,
              managerName: '',
              userCreatedName: o.createdUser,
            }
            customerGridState.customerGrid.data.push(obj)
          })
        }
      }
      return customerGridState
    case 'GETAUTODATAGRID':
      return state
    case 'SAVEAUTODATAGRID':
      const autoGridState = JSON.parse(JSON.stringify(state))
      if (action.payload) {
        autoGridState.autoGrid.totalRow = action.payload.totalItems
        autoGridState.autoGrid.data = []
        action.payload.items.map((o: any) => {
          let obj = {
            id: o.id,
            customerCode: o.customerCode,
            customerVersion: o.customerVersion,
            contractNumber: o.contractNumber,
            originalNumber: o.originalNumber,
            groupDomainCode: o.groupDomainCode,
            groupDomainName: o.groupDomainName,
            customerName: o.customerName,
            sumFee: formatter(o.sumFee + o.sumTax),
            sumFeeName: formatter(o.sumFee + o.sumTax, o.curencyFee) + ' ' + o.curencyFee,
            createdDate: o.createdDate,
            expireDate: o.expireDate,
            source: o.source,
            purchaseDate: o.purchaseDate,
            startDate: o.startDate,
            endDate: o.endDate,
            statusName: o.statusName,
            manager: o.manager,
            managerName: o.managerName,
            userCreatedName: o.userCreatedName,
            partnerCode: o.partnerCode,
            divisionCode: o.divisionCode,
            partnerName: o.partnerName,
            divisionName: o.divisionName,
            quatationNumber: o?.quatationNumber,
            contractTypeName: o.contractTypeName,
            contractType: o.contractType,
            contractKind: o.contractKind,
            companyNameMaster: o.customerMasterName,
            paymentGatewayTypeName: PaymentGatewayType.find((c) => c.value == o.paymentGatewayType)
              ?.label,
            paymentTypeName:
              o.paymentType != 0 ? PaymentType.find((c) => c.value == o.paymentType)?.label : null,
            contractKindName: o.contractKind
              ? ContractKind.find((c) => c.value == o.contractKind)?.label
              : '',
            agent: getAgent(o.exploitingCode),
            productCode: o.productCode,
            divisionId: o.divisionId,
          }
          autoGridState.autoGrid.data.push(obj)
        })
      }
      return autoGridState
    case 'GETMOTODATAGRID':
      return state
    case 'SAVEMOTODATAGRID':
      const motoGridState = JSON.parse(JSON.stringify(state))
      if (action.payload) {
        motoGridState.motoGrid.totalRow = action.payload.totalItems
        motoGridState.motoGrid.data = []
        action.payload.items.map((o: any) => {
          let obj = {
            id: o.id,
            customerCode: o.customerCode,
            customerVersion: o.customerVersion,
            contractNumber: o.contractNumber,
            originalNumber: o.originalNumber,
            groupDomainCode: o.groupDomainCode,
            groupDomainName: o.groupDomainName,
            customerName: o.customerName,
            sumFee: formatter(o.sumFee + o.sumTax),
            sumFeeName: formatter(o.sumFee + o.sumTax, o.curencyFee) + ' ' + o.curencyFee,
            createdDate: o.createdDate,
            expireDate: o.expireDate,
            source: o.source,
            purchaseDate: o.purchaseDate,
            startDate: o.startDate,
            endDate: o.endDate,
            statusName: o.statusName,
            manager: o.manager,
            managerName: o.managerName,
            userCreatedName: o.userCreatedName,
            partnerCode: o.partnerCode,
            divisionCode: o.divisionCode,
            partnerName: o.partnerName,
            divisionName: o.divisionName,
            quatationNumber: o?.quatationNumber,
            contractTypeName: o.contractTypeName,
            contractType: o.contractType,
            contractKind: o.contractKind,
            companyNameMaster: o.customerMasterName,
            paymentGatewayTypeName: PaymentGatewayType.find((c) => c.value == o.paymentGatewayType)
              ?.label,
            paymentTypeName:
              o.paymentType != 0 ? PaymentType.find((c) => c.value == o.paymentType)?.label : null,
            contractKindName: o.contractKind
              ? ContractKind.find((c) => c.value == o.contractKind)?.label
              : '',
            agent: getAgent(o.exploitingCode),
            productCode: o.productCode,
            divisionId: o.divisionId,
          }
          motoGridState.motoGrid.data.push(obj)
        })
      }
      return motoGridState
    case 'GETHOUSEDATAGRID':
      return state
    case 'SAVEHOUSEDATAGRID':
      const houseGridState = JSON.parse(JSON.stringify(state))
      if (action.payload) {
        houseGridState.houseGrid.totalRow = action.payload.totalItems
        houseGridState.houseGrid.data = []
        action.payload.items.map((o: any) => {
          let obj = {
            id: o.id,
            customerCode: o.customerCode,
            customerVersion: o.customerVersion,
            contractNumber: o.contractNumber,
            source: o.source,
            originalNumber: o.originalNumber,
            groupDomainCode: o.groupDomainCode,
            groupDomainName: o.groupDomainName,
            customerName: o.customerName,
            sumFee: formatter(o.sumFee),
            sumFeeName: formatter(o.sumFee, o.curencyFee) + ' ' + o.curencyFee,
            createdDate: o.createdDate,
            expireDate: o.expireDate,
            purchaseDate: o.purchaseDate,
            startDate: o.startDate,
            endDate: o.endDate,
            statusName: o.statusName,
            manager: o.manager,
            managerName: o.managerName,
            userCreatedName: o.userCreatedName,
            partnerCode: o.partnerCode,
            divisionCode: o.divisionCode,
            partnerName: o.partnerName,
            divisionName: o.divisionName,
            contractTypeName: o.contractTypeName,
            contractType: o.contractType,
            contractKind: o.contractKind,
            contractKindName: o.contractKind
              ? ContractKind.find((c) => c.value == o.contractKind)?.label
              : '',
            productCode: o.productCode,
            divisionId: o.divisionId,
          }
          houseGridState.houseGrid.data.push(obj)
        })
      }
      return houseGridState
    case 'GETPAYMENTDATAGRID':
      return state
    case 'SAVEPAYMENTDATAGRID':
      const paymentGridState = JSON.parse(JSON.stringify(state))
      if (action.payload) {
        if (action.payload.length > 0)
          paymentGridState.paymentGrid.totalRow = action.payload[0]?.totalrow
        paymentGridState.paymentGrid.data = []
        action.payload.map((o: any) => {
          let obj = {
            id: o.id,
            customerCode: o.customerCode,
            customerName: o.customerName,
            version: o.version,
            partnerCode: o.partnerCode,
            divisionCode: o.divisionCode,
            partnerName: o.partnerName,
            divisionName: o.divisionName,
            datePayment: o.sellingPaymentType != 3 ? o.datePayment : null,
            sumFee: formatter(o.sumFee),
            userName: o.userName,
            sellingPaymentType: TypeOfFee.find((x) => x.value == o.sellingPaymentType)?.label,
            curency: o.curency,
            exchangeRate: o.exchangeRate,
            contractNumber: o.contractNumber,
            dateCancel: o.sellingPaymentType == 3 ? o.datePayment : null,
            paymentGatewayName: PaymentGatewayType.find((x) => x.value == o.paymentGatewayType)
              ?.label,
            paymentTypeName:
              PaymentType.find((x) => x.value == o.paymentType)?.value == 0
                ? null
                : PaymentType.find((x) => x.value == o.paymentType)?.label,
            startDate: o?.startDate,
            expireDate: o?.expireDate,
            sellingContractId: o.sellingContractId,
          }
          paymentGridState.paymentGrid.data.push(obj)
        })
      }
      return paymentGridState
    case 'GETCERTIFICATEDATAGRID':
      return state
    case 'SAVECERTIFICATEDATAGRID':
      const certificateGridState = JSON.parse(JSON.stringify(state))
      if (action.payload) {
        if (action.payload.length > 0)
          certificateGridState.certificateGrid.totalRow = action.payload[0]?.totalrow
        certificateGridState.certificateGrid.data = []
        action.payload.map((o: any) => {
          let obj = {
            id: o.id,
            certCode: o.certCode,
            expireDate: moment(o.expireDate, 'YYYY-MM-DD').format('DD/MM/YYYY'),
            from: o.from,
            groupdomainCode: o.groupdomainCode,
            groupdomainName: o.groupdomainName,
            startDate: moment(o.startDate, 'YYYY-MM-DD').format('DD/MM/YYYY'),
            to: o.to,
          }
          certificateGridState.certificateGrid.data.push(obj)
        })
      }
      return certificateGridState
    case 'GETCERTIFICATEMANAGEDATAGRID':
      return state
    case 'SAVECERTIFICATEMANAGEDATAGRID':
      const certificateManageGridState = JSON.parse(JSON.stringify(state))
      if (action.payload) {
        if (action.payload.length > 0)
          certificateManageGridState.certificateManageGrid.totalRow = action.payload[0]?.totalrow
        certificateManageGridState.certificateManageGrid.data = []
        action.payload.map((o: any) => {
          let obj = {
            id: o.id,
            code: o.code,
            date: o.date,
            certificateManagerType: o.certificateManagerType,
            certificateManagerTypeName: CertificateManagerType.find(
              (c) => c.value == o.certificateManagerType
            )?.label,
            division: o.division,
            divisionName: o.divisionName,
            divisionTransfer: o.divisionTransfer,
            divisionTransferName: o.divisionTransferName,
            note: o.note,
            partner: o.partner,
            partnerName: o.partnerName,
            partnerTransfer: o.partnerTransfer,
            partnerTransferName: o.partnerTransferName,
            userCreatedName: o.userCreatedName,
            userName: o.userName,
            receiveType: o.receiveType,
          }
          certificateManageGridState.certificateManageGrid.data.push(obj)
        })
      }
      return certificateManageGridState
    case 'GETCOMMISSIONDATAGRID':
      return state
    case 'SAVECOMMISSIONDATAGRID':
      const commissionGridState = JSON.parse(JSON.stringify(state))
      if (action.payload) {
        if (action.payload.length > 0)
          commissionGridState.commissionGrid.totalRow = action.payload[0]?.totalrow
        commissionGridState.commissionGrid.data = []
        action.payload.map((o: any) => {
          let obj = {
            id: o.id,
            customerCode: o.customerCode,
            customerName: o.customerName,
            version: o.version,
            partnerCode: o.partnerCode,
            divisionCode: o.divisionCode,
            partnerName: o.partnerName,
            divisionName: o.divisionName,
            datePayment: o.datePayment,
            userName: o.userName,
            curency: o.curency,
            exchangeRate: o.exchangeRate,
            sumCommissionMoney: o?.sumCommissionMoney ? formatter(o.sumCommissionMoney) : 0,
            sumBonusMoney: o?.sumBonusMoney ? formatter(o.sumBonusMoney) : 0,
          }
          commissionGridState.commissionGrid.data.push(obj)
        })
      }
      return commissionGridState
    case 'GETRENEWDATAGRID':
      return state
    case 'SAVERENEWDATAGRID':
      const renewGridState = JSON.parse(JSON.stringify(state))
      if (action.payload) {
        renewGridState.renewGrid.totalRow = action.payload.totalItems
        renewGridState.renewGrid.data = []
        action.payload.items.map((o: any) => {
          let obj = {
            id: o.id,
            code: o.code,
            oldContractNumber: o?.oldContractNumber,
            idOldContract: o?.idOldContract,
            idNewContract: o?.idNewContract,
            insuranceMarkets: o?.insuranceMarkets,
            customerCode: o.customerCode,
            customerVersion: o.customerVersion,
            contractNumber: o.oldContractNumber,
            newContractNumber: o.newContractNumber,
            renewTypeName: o.renewTypeName,
            originalNumber: o.originalNumber,
            groupDomainCode: o.groupDomainCode,
            groupDomainName: o.groupDomainName,
            businessProgramCode: o.businessProgramCode,
            businessName: o.businessName,
            customerName: o.customerName,
            sumFee: formatter(o.sumFee),
            sumFeeName: formatter(o.sumFee, o.curencyFee),
            createdDate: o.createdDate,
            expireDate: moment(o.expireDate, 'DD/MM/YYYY').format('DD/MM/YYYY'),
            source: o.source,
            purchaseDate: o.purchaseDate,
            productCode: o.productCode,
            startDate: o.startDate,
            endDate: o.endDate,
            statusName: o.renewTypeName,
            manager: o.manager,
            managerName: o.managerName,
            userCreatedName: o.userCreatedName,
            partnerCode: o.partnerCode,
            divisionCode: o.divisionCode,
            partnerName: o.partnerName,
            divisionName: o.divisionName,
            contractTypeName: o.contractTypeName,
            contractType: o.contractType,
            contractKind: o.contractKind,
            note: o.note,
            email: o?.email,
            phone: o?.phone,
            contractKindName: o.contractKind
              ? ContractKind.find((c) => c.value == o.contractKind)?.label
              : '',
          }
          renewGridState.renewGrid.data.push(obj)
        })
      }
      return renewGridState
    case 'GETCHECKMONEYDATAGRID':
      return state
    case 'SAVECHECKMONEYDATAGRID':
      const gridCheckMoneyState = JSON.parse(JSON.stringify(state))
      if (action.payload) {
        gridCheckMoneyState.checkMoneyGrid.totalRow = action.payload.totalItems
        gridCheckMoneyState.checkMoneyGrid.data = []
        action.payload.items.map((o: any) => {
          let obj = {
            id: o.id,
            customerCode: o.customerCode,
            customerVersion: o.customerVersion,
            contractNumber: o.contractNumber,
            originalNumber: o.originalNumber,
            groupDomainCode: o.groupDomainCode,
            groupDomainName: o.groupDomainName,
            customerName: o.customerName,
            sumFee: formatter(o.sumFee),
            sumFeeName: formatter(o.sumFee, o.curencyFee) + ' ' + o.curencyFee,
            createdDate: o.createdDate,
            expireDate: o.expireDate,
            source: o.source,
            purchaseDate: o.purchaseDate,
            startDate: o.startDate,
            endDate: o.endDate,
            statusName: o.statusName,
            manager: o.manager,
            managerName: o.managerName,
            userCreatedName: o.userCreatedName,
            partnerCode: o.partnerCode,
            divisionCode: o.divisionCode,
            partnerName: o.partnerName,
            divisionName: o.divisionName,
            quatationNumber: o?.quatationNumber,
            contractTypeName: o.contractTypeName,
            contractType: o.contractType,
            contractKind: o.contractKind,
            contractKindName: o.contractKind
              ? ContractKind.find((c) => c.value == o.contractKind)?.label
              : '',
          }
          gridCheckMoneyState.checkMoneyGrid.data.push(obj)
        })
      }
      return gridCheckMoneyState
    case 'GETPAYMENTSALARYDATAGRID':
      return state
    case 'SAVEPAYMENTSALARYDATAGRID':
      const gridPaymentSalaryState = JSON.parse(JSON.stringify(state))
      if (action.payload) {
        gridPaymentSalaryState.paymentSalaryGrid.totalRow = action.payload.totalItems
        gridPaymentSalaryState.paymentSalaryGrid.data = []
        action.payload.items.map((o: any) => {
          let obj = {
            id: o.id,
            customerCode: o.customerCode,
            customerVersion: o.customerVersion,
            businessProgramCode: o.businessProgramCode,
            code: o.code,
            originalCode: o.originalCode,
            contractNumber: o.contractNumber,
            originalNumber: o.originalNumber,
            groupDomainCode: o.groupDomainCode,
            groupDomainName: o.groupDomainName,
            customerName: o.customerName,
            sumFee: formatter(o.sumFee),
            sumFeeName: formatter(o.sumFee, o.curencyFee) + ' ' + o.curencyFee,
            createdDate: o.createdDate,
            expireDate: o.expireDate,
            source: o.source,
            purchaseDate: o.purchaseDate,
            startDate: o.startDate,
            endDate: o.endDate,
            statusName: o.statusName,
            manager: o.manager,
            managerName: o.managerName,
            userCreatedName: o.userCreatedName,
            partnerCode: o.partnerCode,
            divisionCode: o.divisionCode,
            partnerName: o.partnerName,
            divisionName: o.divisionName,
            quatationNumber: o?.quatationNumber,
            contractTypeName: o.contractTypeName,
            contractType: o.contractType,
            contractKind: o.contractKind,
            contractKindName: o.contractKind
              ? ContractKind.find((c) => c.value == o.contractKind)?.label
              : '',
          }
          gridPaymentSalaryState.paymentSalaryGrid.data.push(obj)
        })
      }
      return gridPaymentSalaryState
    case 'GETCARGODATAGRID':
      return state
    case 'SAVECARGODATAGRID':
      const gridCargoState = JSON.parse(JSON.stringify(state))
      if (action.payload) {
        gridCargoState.cargoGrid.totalRow = action.payload.totalItems
        gridCargoState.cargoGrid.data = []
        action.payload.items.map((o: any) => {
          let obj = {
            id: o.id,
            customerCode: o.customerCode,
            customerVersion: o.customerVersion,
            contractNumber: o.contractNumber,
            originalNumber: o.originalNumber,
            groupDomainCode: o.groupDomainCode,
            groupDomainName: o.groupDomainName,
            customerName: o.customerName,
            sumFee: formatter(o.sumFee),
            sumFeeName: formatter(o.sumFee, o.curencyFee) + ' ' + o.curencyFee,
            createdDate: o.createdDate,
            expireDate: o.expireDate !== '01/01/0001' ? o.expireDate : null,
            source: o.source,
            purchaseDate: o.purchaseDate !== '01/01/0001' ? o.purchaseDate : null,
            startDate: o.startDate !== '01/01/0001' ? o.startDate : null,
            endDate: o.endDate,
            statusName: o.statusName,
            manager: o.manager,
            managerName: o.managerName,
            userCreatedName: o.userCreatedName,
            partnerCode: o.partnerCode,
            divisionCode: o.divisionCode,
            partnerName: o.partnerName,
            divisionName: o.divisionName,
            quatationNumber: o?.quatationNumber,
            contractTypeName: o.contractTypeName,
            contractType: o.contractType,
            contractKind: o.contractKind,
            companyNameMaster: o.customerMasterName,
            contractKindName: o.contractKind
              ? ContractKind.find((c) => c.value == o.contractKind)?.label
              : '',
            agent: getAgent(o.exploitingCode),
            productCode: o.productCode,
          }
          gridCargoState.cargoGrid.data.push(obj)
        })
      }
      return gridCargoState
    case 'GETMARINEDATAGRID':
      return state
    case 'SAVEMARINEDATAGRID':
      const gridMarineState = JSON.parse(JSON.stringify(state))
      if (action.payload) {
        gridMarineState.marineGrid.totalRow = action.payload.totalItems
        gridMarineState.marineGrid.data = []
        action.payload.items.map((o: any) => {
          let obj = {
            id: o.id,
            customerCode: o.customerCode,
            customerVersion: o.customerVersion,
            contractNumber: o.contractNumber,
            originalNumber: o.originalNumber,
            groupDomainCode: o.groupDomainCode,
            groupDomainName: o.groupDomainName,
            customerName: o.customerName,
            sumFee: formatter(o.sumFee),
            sumFeeName: formatter(o.sumFee, o.curencyFee) + ' ' + o.curencyFee,
            createdDate: o.createdDate,
            expireDate: o.expireDate,
            source: o.source,
            purchaseDate: o.purchaseDate,
            startDate: o.startDate,
            endDate: o.endDate,
            statusName: o.statusName,
            manager: o.manager,
            managerName: o.managerName,
            userCreatedName: o.userCreatedName,
            partnerCode: o.partnerCode,
            divisionCode: o.divisionCode,
            partnerName: o.partnerName,
            divisionName: o.divisionName,
            quatationNumber: o?.quatationNumber,
            contractTypeName: o.contractTypeName,
            contractType: o.contractType,
            contractKind: o.contractKind,
            companyNameMaster: o.customerMasterName,
            contractKindName: o.contractKind
              ? ContractKind.find((c) => c.value == o.contractKind)?.label
              : '',
            agent: getAgent(o.exploitingCode),
            productCode: o.productCode,
            divisionId: o.divisionId,
          }
          gridMarineState.marineGrid.data.push(obj)
        })
      }
      return gridMarineState
    case 'GETPROPERTYDATAGRID':
      return state
    case 'SAVEPROPERTYDATAGRID':
      const gridPropertyState = JSON.parse(JSON.stringify(state))
      if (action.payload) {
        gridPropertyState.propertyGrid.totalRow = action.payload.totalItems
        gridPropertyState.propertyGrid.data = []
        action.payload.items.map((o: any) => {
          let obj = {
            id: o.id,
            customerCode: o.customerCode,
            customerVersion: o.customerVersion,
            contractNumber: o.contractNumber,
            originalNumber: o.originalNumber,
            groupDomainCode: o.groupDomainCode,
            groupDomainName: o.groupDomainName,
            customerName: o.customerName,
            sumFee: formatter(o.sumFee),
            sumFeeName: formatter(o.sumFee, o.curencyFee) + ' ' + o.curencyFee,
            createdDate: o.createdDate,
            expireDate: o.expireDate,
            source: o.source,
            purchaseDate: o.purchaseDate,
            startDate: o.startDate,
            endDate: o.endDate,
            statusName: o.statusName,
            manager: o.manager,
            managerName: o.managerName,
            userCreatedName: o.userCreatedName,
            partnerCode: o.partnerCode,
            divisionCode: o.divisionCode,
            partnerName: o.partnerName,
            divisionName: o.divisionName,
            quatationNumber: o?.quatationNumber,
            contractTypeName: o.contractTypeName,
            contractType: o.contractType,
            contractKind: o.contractKind,
            companyNameMaster: o.customerMasterName,
            contractKindName: o.contractKind
              ? ContractKind.find((c) => c.value == o.contractKind)?.label
              : '',
            agent: getAgent(o.exploitingCode),
            productCode: o.productCode,
            divisionId: o.divisionId,
          }
          gridPropertyState.propertyGrid.data.push(obj)
        })
      }
      return gridPropertyState
    case 'GETTECHNICALDATAGRID':
      return state
    case 'SAVETECHNICALDATAGRID':
      const gridTechnicalState = JSON.parse(JSON.stringify(state))
      if (action.payload) {
        gridTechnicalState.technicalGrid.totalRow = action.payload.totalItems
        gridTechnicalState.technicalGrid.data = []
        action.payload.items.map((o: any) => {
          let obj = {
            id: o.id,
            customerCode: o.customerCode,
            customerVersion: o.customerVersion,
            contractNumber: o.contractNumber,
            originalNumber: o.originalNumber,
            groupDomainCode: o.groupDomainCode,
            groupDomainName: o.groupDomainName,
            customerName: o.customerName,
            sumFee: formatter(o.sumFee),
            sumFeeName: formatter(o.sumFee, o.curencyFee) + ' ' + o.curencyFee,
            createdDate: o.createdDate,
            expireDate: o.expireDate,
            source: o.source,
            purchaseDate: o.purchaseDate,
            startDate: o.startDate,
            endDate: o.endDate,
            statusName: o.statusName,
            manager: o.manager,
            managerName: o.managerName,
            userCreatedName: o.userCreatedName,
            partnerCode: o.partnerCode,
            divisionCode: o.divisionCode,
            partnerName: o.partnerName,
            divisionName: o.divisionName,
            quatationNumber: o?.quatationNumber,
            contractTypeName: o.contractTypeName,
            contractType: o.contractType,
            contractKind: o.contractKind,
            companyNameMaster: o.customerMasterName,
            contractKindName: o.contractKind
              ? ContractKind.find((c) => c.value == o.contractKind)?.label
              : '',
            agent: getAgent(o.exploitingCode),
            productCode: o.productCode,
            divisionId: o.divisionId,
          }
          gridTechnicalState.technicalGrid.data.push(obj)
        })
      }
      return gridTechnicalState
    case 'GETMICRODATAGRID':
      return state
    case 'SAVEMICRODATAGRID':
      const gridMicroState = JSON.parse(JSON.stringify(state))
      if (action.payload) {
        gridMicroState.microGrid.totalRow = action.payload.totalItems
        gridMicroState.microGrid.data = []
        action.payload.items.map((o: any) => {
          let obj = {
            id: o.id,
            customerCode: o.customerCode,
            customerVersion: o.customerVersion,
            contractNumber: o.contractNumber,
            originalNumber: o.originalNumber,
            groupDomainCode: o.groupDomainCode,
            groupDomainName: o.groupDomainName,
            customerName: o.customerName,
            sumFee: formatter(o.sumFee),
            sumFeeName: formatter(o.sumFee, o.curencyFee) + ' ' + o.curencyFee,
            createdDate: o.createdDate,
            expireDate: o.expireDate,
            source: o.source,
            purchaseDate: o.purchaseDate,
            startDate: o.startDate,
            endDate: o.endDate,
            statusName: o.statusName,
            manager: o.manager,
            managerName: o.managerName,
            userCreatedName: o.userCreatedName,
            partnerCode: o.partnerCode,
            divisionCode: o.divisionCode,
            partnerName: o.partnerName,
            divisionName: o.divisionName,
            quatationNumber: o?.quatationNumber,
            contractTypeName: o.contractTypeName,
            contractType: o.contractType,
            contractKind: o.contractKind,
            companyNameMaster: o.customerMasterName,
            contractKindName: o.contractKind
              ? ContractKind.find((c) => c.value == o.contractKind)?.label
              : '',
            agent: getAgent(o.exploitingCode),
            productCode: o.productCode,
            divisionId: o.divisionId,
          }
          gridMicroState.microGrid.data.push(obj)
        })
      }
      return gridMicroState
    default:
      return state
  }
}

export function* gridSaga() {
  yield takeLatest('GETHEALTHDATAGRID', function* getHealthDataGridSaga(action: any) {
    try {
      //@ts-ignore
      const response: any = yield call(searchAndPagingContract, action.payload)
      if (response && !response.isError) {
        yield put(gridActions.saveHealthDataGrid(response.data))
      }
    } catch (error) {
      return
    }
  })
  yield takeLatest('GETAUTODATAGRID', function* getAutoDataGridSaga(action: any) {
    try {
      //@ts-ignore
      const response: any = yield call(searchAndPagingContract, action.payload)
      if (response && !response.isError) {
        yield put(gridActions.saveAutoDataGrid(response.data))
      }
    } catch (error) {
      return
    }
  })
  yield takeLatest('GETMOTODATAGRID', function* getMotoDataGridSaga(action: any) {
    try {
      //@ts-ignore
      const response: any = yield call(searchAndPagingContract, action.payload)
      if (response && !response.isError) {
        yield put(gridActions.saveMotoDataGrid(response.data))
      }
    } catch (error) {
      return
    }
  })
  yield takeLatest('GETHOUSEDATAGRID', function* getHouseDataGridSaga(action: any) {
    try {
      //@ts-ignore
      const response: any = yield call(searchAndPagingContract, action.payload)
      if (response && !response.isError) {
        yield put(gridActions.saveHouseDataGrid(response.data))
      }
    } catch (error) {
      return
    }
  })
  yield takeLatest('GETCUSTOMERDATAGRID', function* getCustomerDataGridSaga(action: any) {
    try {
      //@ts-ignore
      const response: any = yield call(searchAndPagingUser, action.payload)
      if (response && !response.isError) {
        yield put(gridActions.saveCustomerDataGrid(response.data))
      }
    } catch (error) {
      return
    }
  })
  yield takeLatest('GETPAYMENTDATAGRID', function* getPaymentDataGridSaga(action: any) {
    try {
      //@ts-ignore
      const response: any = yield call(getListPayment, action.payload)
      if (response && !response.isError) {
        yield put(gridActions.savePaymentDataGrid(response.data))
      }
    } catch (error) {
      return
    }
  })
  yield takeLatest('GETCOMMISSIONDATAGRID', function* getCommissionDataGridSaga(action: any) {
    try {
      //@ts-ignore
      const response: any = yield call(getListCommission, action.payload)
      if (response && !response.isError) {
        yield put(gridActions.saveCommissionDataGrid(response.data))
      }
    } catch (error) {
      return
    }
  })
  yield takeLatest('GETRENEWDATAGRID', function* getRenewDataGridSaga(action: any) {
    try {
      //@ts-ignore
      const response: any = yield call(searchAndPagingRenewContract, action.payload)
      if (response && !response.isError) {
        yield put(gridActions.saveRenewDataGrid(response.data))
      }
    } catch (error) {
      return
    }
  })
  yield takeLatest('GETCERTIFICATEDATAGRID', function* getCertificateDataGridSaga(action: any) {
    try {
      //@ts-ignore
      const response: any = yield call(getListCertificate, action.payload)
      if (response && !response.isError) {
        yield put(gridActions.saveCertificateDataGrid(response.data))
      }
    } catch (error) {
      return
    }
  })
  yield takeLatest(
    'GETCERTIFICATEMANAGEDATAGRID',
    function* getCertificateDataGridSaga(action: any) {
      try {
        //@ts-ignore
        const response: any = yield call(getListCertificateManage, action.payload)
        if (response && !response.isError) {
          yield put(gridActions.saveCertificateManageDataGrid(response.data))
        }
      } catch (error) {
        return
      }
    }
  )
  yield takeLatest('GETCHECKMONEYDATAGRID', function* getCheckMoneyDataGridSaga(action: any) {
    try {
      //@ts-ignore
      const response: any = yield call(searchAndPagingContract, action.payload)
      if (response && !response.isError) {
        yield put(gridActions.saveCheckMoneyDataGrid(response.data))
      }
    } catch (error) {
      return
    }
  })
  yield takeLatest('GETPAYMENTSALARYDATAGRID', function* getPaymentSalaryDataGridSaga(action: any) {
    try {
      //@ts-ignore
      const response: any = yield call(searchAndPagingContract, action.payload)
      if (response && !response.isError) {
        yield put(gridActions.savePaymentSalaryDataGrid(response.data))
      }
    } catch (error) {
      return
    }
  })
  yield takeLatest('GETCARGODATAGRID', function* getCargoDataGridSaga(action: any) {
    try {
      //@ts-ignore
      const response: any = yield call(searchAndPagingContract, action.payload)
      if (response && !response.isError) {
        yield put(gridActions.saveCargoDataGrid(response.data))
      }
    } catch (error) {
      return
    }
  })
  yield takeLatest('GETMARINEDATAGRID', function* getMarineDataGridSaga(action: any) {
    try {
      //@ts-ignore
      const response: any = yield call(searchAndPagingContract, action.payload)
      if (response && !response.isError) {
        yield put(gridActions.saveMarineDataGrid(response.data))
      }
    } catch (error) {
      return
    }
  })
  yield takeLatest('GETPROPERTYDATAGRID', function* getPropertyDataGridSaga(action: any) {
    try {
      //@ts-ignore
      const response: any = yield call(searchAndPagingContract, action.payload)
      if (response && !response.isError) {
        yield put(gridActions.savePropertyDataGrid(response.data))
      }
    } catch (error) {
      return
    }
  })
  yield takeLatest('GETTECHNICALDATAGRID', function* getTechnicalDataGridSaga(action: any) {
    try {
      //@ts-ignore
      const response: any = yield call(searchAndPagingContract, action.payload)
      if (response && !response.isError) {
        yield put(gridActions.saveTechnicalDataGrid(response.data))
      }
    } catch (error) {
      return
    }
  })
  yield takeLatest('GETMICRODATAGRID', function* getMicroDataGridSaga(action: any) {
    try {
      //@ts-ignore
      const response: any = yield call(searchAndPagingContract, action.payload)
      if (response && !response.isError) {
        yield put(gridActions.saveMicroDataGrid(response.data))
      }
    } catch (error) {
      return
    }
  })
}
